// eslint-disable-next-line unicorn/filename-case
import { defineMessages } from 'react-intl';

export default defineMessages({ 
    startpagecancelChangeTitleMEL:{
        // eslint-disable-next-line no-secrets/no-secrets
        "id":"CPMIpayrollreporting.requestchangeMEL.Cancel payroll reporting update",
        "defaultMessage":"Cancel payroll reporting update"
    },
    startpagecancelChangeMessageMEL:{
        // eslint-disable-next-line no-secrets/no-secrets
        "id":"CPMIpayrollreporting.requestchangeMEL.Are you sure you want to cancel your payroll reporting changes?",
        "defaultMessage":"Are you sure you want to cancel your payroll reporting changes?"
    },
    // submitTitle:{
    //     "id":"CPMIpayrollreporting.requestchange.Certify Payroll",
    //     "defaultMessage":"Certify Payroll"
    // },
    draftErrorMessageMEL:{
        // eslint-disable-next-line no-secrets/no-secrets
        "id":"CPMIpayrollreporting.requestchangeMEL.We are currently unable to access your data. Please contact us at 1.800.231.1363 so that we can assist.",
        "defaultMessage":"We are currently unable to access your data. Please contact us at 1.800.231.1363 so that we can assist."
    },
    // submitMessage:{
    //     "id":"CPMIpayrollreporting.requestchange.AI certify that payroll figures appearing in this report are true and a complete statement of all the earnings by all of our employees for the period stated.",
    //     "defaultMessage":"I certify that payroll figures appearing in this report are true and a complete statement of all the earnings by all of our employees for the period stated."
    // },

});
